/* eslint-disable react/prop-types */
/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://example.comproduct/material-kit-react
* Copyright 2023  (https://)

Coded by 

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKAvatar from "components/MKAvatar";
import MKTypography from "components/MKTypography";

function DefaultReviewCard({ image, name, date, review, rating }) {
  return (
    <MKBox
      variant="contained"
      borderRadius="lg"
      p={3}
      sx={{
        backgroundColor: ({ palette: { background } }) => background.default,
        height: "100%",
        boxShadow: ({ boxShadows: { md } }) => md,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <MKBox display="flex" alignItems="center" mb={2}>
        <MKAvatar src={image} alt={name} size="md" variant="rounded" shadow="md" sx={{ mr: 2 }} />
        <MKBox>
          <MKTypography variant="h6" fontWeight="bold">
            {name}
          </MKTypography>
          <MKTypography variant="caption" color="text">
            {date}
          </MKTypography>
        </MKBox>
      </MKBox>
      <MKTypography variant="body2" color="text" sx={{ flex: 1, my: 2.5 }}>
        &quot;{review}&quot;
      </MKTypography>
      {rating}
    </MKBox>
  );
}

// Setting default values for the props of DefaultReviewCard
DefaultReviewCard.defaultProps = {
  date: "",
  rating: null,
};

// Typechecking props for the DefaultReviewCard
DefaultReviewCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  date: PropTypes.string,
  review: PropTypes.string.isRequired,
  rating: PropTypes.node,
};

export default DefaultReviewCard;
